import { tCalendar } from '../../lib/calendar-i18n';

/**
 * 일정 창·회의실 표가 같이 쓰는 시각 글자 (2026-10-19 정리 — 날짜·시간 피커·드럼·회의실 표·고른 방 요약이
 * 같은 식을 따로 적던 것을 하나로).
 */

export const pad2 = (n: number) => String(n).padStart(2, '0');

/**
 * 24시간제 시(0~23) → 화면의 1~12시.
 * ⭐ **2026-10-16 — 자정은 「오전 12」**(사용자 결정 「오전 12 = 자정 유지, 표시만 12」).
 *   시간 드럼이 1~12시라 자정은 「오전 · 12」로 고른다 — 머리·트리거 글자도 같은 말을 하게 했다.
 *   종전(2026-10-06)에는 「오전 0시」였다.
 * ⚠ 이 범위 밖(`lib/base-i18n.ts` formatTime · `DayAgendaView.tsx` hour12)은 아직 「오전 0시」다.
 */
export function displayHour12(h: number): number {
  return h % 12 === 0 ? 12 : h % 12;
}

/** 「오후 2:00」 — 오전/오후 + 1~12시 + 분 두 자리. */
export function formatAmPmTime(d: Date): string {
  const ampm = tCalendar(d.getHours() < 12 ? 'calendar.picker.am' : 'calendar.picker.pm');
  return `${ampm} ${displayHour12(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** 날짜·시간 피커의 값 꼴('YYYY-MM-DDTHH:mm', 현지). */
export function toPickerValue(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
